import {
  SET_NEWSUPDATE_LOADING,
  SET_NEWSUPDATE,
  SET_ASSIGN_USERS,
  ADD_NEWS,
  EDIT_NEWS,
  SET_ASSIGN_ROLES_AND_USERS,
  SET_ASSIGN_ROLES_AND_USERS_LOADING,
  DELETE_NEWS,
  ROLE_ID_DATA,
  SET_ASSIGN_USERS_LOCATION,
  SET_ASSIGN_USERS_LOCATION_LOADING,
  SET_MY_NEWS_DATA,
  SET_MY_NEWS_DATA_LOADING,
  GET_USERS_COMPANY_DATA,
  GET_USERS_COMPANY_DATA_LOADING,
  GET_NEWS_REPORT_DATA,
  GET_NEWS_REPORT_DATA_LOADING,
  GET_USER_REPORT_DATA,
  GET_USER_REPORT_DATA_LOADING,
} from "./constants";

const initialState = {
  isLoading: true,
  isnewsUpdateLoading: true,
  isMyNewsLoading: true,
  getRolesAndUsersLoading: true,
  getAssignLocationsDataLoading: true,
  isCompanyUsersDataLoading: true,
  newsReportDataLoading: true,
  userReportDataLoading: true,
  myNewsData: [],
  newsReportData: [],
  userReportData: [],
  newsUpdateData: [],
  assignUserData: [],
  assignRolesData: [],
  assignUserdataa: [],
  newsData: [],
  roleIdData: [],
  getCompanyUsersData: [],
  assignUserlocationData: [],
  total_pages: 0,
};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_NEWS_REPORT_DATA_LOADING:
      return {
        ...state,
        newsReportDataLoading: payload,
      };
    case GET_NEWS_REPORT_DATA:
      return {
        ...state,
        newsReportDataLoading: false,
        newsReportData: payload,
      };
    case GET_USER_REPORT_DATA_LOADING:
      return {
        ...state,
        userReportDataLoading: payload,
      };
    case GET_USER_REPORT_DATA:
      return {
        ...state,
        userReportDataLoading: false,
        userReportData: payload,
      };
    case SET_MY_NEWS_DATA_LOADING:
      return {
        ...state,
        isMyNewsLoading: payload,
      };
    case SET_MY_NEWS_DATA:
      return {
        ...state,
        isMyNewsLoading: false,
        myNewsData: payload,
      };
    case SET_NEWSUPDATE_LOADING:
      return {
        ...state,
        isLoading: payload,
        isnewsUpdateLoading: payload,
      };
    case SET_NEWSUPDATE:
      return {
        ...state,
        isLoading: false,
        isnewsUpdateLoading: false,
        newsUpdateData: payload.result,
        total_pages: payload.totalPages,
        newsData: payload,
      };
    case SET_ASSIGN_USERS:
      return {
        ...state,
        isLoading: false,
        assignUserData: payload.rolesData,
      };
    case SET_ASSIGN_USERS_LOCATION_LOADING:
      return {
        ...state,
        getAssignLocationsDataLoading: payload,
      };
    case SET_ASSIGN_USERS_LOCATION:
      return {
        ...state,
        isLoading: false,
        getAssignLocationsDataLoading: false,
        assignUserlocationData: payload.locationData,
      };
    case GET_USERS_COMPANY_DATA_LOADING:
      return {
        ...state,
        isCompanyUsersDataLoading: payload,
      };
    case GET_USERS_COMPANY_DATA:
      return {
        ...state,
        isCompanyUsersDataLoading: false,
        getCompanyUsersData: payload.result,
      };
    case ROLE_ID_DATA:
      return {
        ...state,
        isLoading: false,
        roleIdData: payload.rolesData,
      };
    case SET_ASSIGN_ROLES_AND_USERS_LOADING:
      return {
        ...state,
        getRolesAndUsersLoading: payload,
      };
    case SET_ASSIGN_ROLES_AND_USERS:
      return {
        ...state,
        getRolesAndUsersLoading: false,
        assignRolesData: payload.rolesData,
        assignUserdataa: payload.UserData,
      };
    case ADD_NEWS:
      return {
        ...state,
        isLoading: false,
        newsUpdateData: [...state.newsUpdateData, payload],
      };
    case EDIT_NEWS:
      return {
        ...state,
        isLoading: false,
        newsUpdateData: state.newsUpdateData.map((item) =>
          item._id === payload._id ? { ...payload } : item
        ),
      };
    case DELETE_NEWS:
      return {
        ...state,
        isLoading: false,
        newsUpdateData: state.newsUpdateData.map((item) =>
          item._id === payload._id ? { ...payload } : item
        ),
      };
    default:
      return state;
  }
};

export default Reducer;
